"use client"

import React, { useState, useRef, useEffect } from "react";
import Image from "next/image";

export default function UserReviews({ backgroundColor = "bg-white" }) {
  const reviews = [
    {
      title: "Great App!",
      name: "gitarklara",
      body:
        "Such a fun and easy way to learn how to play guitar. The app makes you keep practising and it feels good when you get that instant feedback of ones progress.",
    },
    {
      title: "Helping Fulfill a Life-Long Dream",
      name: "Suburban Assassin",
      body:
        "This app is amazing. Easy to understand and use. In a few short weeks, had some basics down to start playing with confidence. I had zero guitar experience except for a few failed attempts to learn back in college. The apps approach to learning is great and you can go real deep into music theory if you choose to. The team running the app also does a great job adding new music across varying skill levels, keeping things fresh, exciting and challenging.",
    },
    {
      title: "Game changing unique technology",
      name: "Guitarobsession",
      body:
        "This app has changed my life after trying to find a way to learn guitar for years and finally gave up a few years ago. The design and flow of the app make the learning curve super easy to understand and their AR technique make you feel like a pro from day 1! I’m into my 4th week using and I can’t wait to play my next lesson. Superior from all other apps and it REALLY work! Thank you Zoundio and Gibson.",
    },
    {
      title: "Like having your own private tutor",
      name: "Sordini",
      body:
        "I’ve played basic guitar off and on for the last 30 years. This app has not only helped me rediscover the joy of playing an instrument but has also taken my skills to new heights in a pedagogical and fun way. I even learned picking which is something I’ve always struggled with. And who doesn’t want to play a duet with Mark Knopfler? I really recommend it no matter your skill level. Invest in it and you invest in yourself. Have fun!",
    },
    {
      title: "Reignited my love of playing the guitar",
      name: "pacman180",
      body:
        "Had been stuck playing the same few songs, riffs and chords for years(decades even). Difficult to find time for lessons between work and family life. Have had this app for a few weeks and my playing is progressed more in that time than the last 20 years! Absolutely brilliant and really enjoying rocking along with my favourite Guns and Roses tunes! Keep up the good work!",
    },
    {
      title: "This app is great!",
      name: "William Entz",
      body:
        "I bought this app in the first week I got my guitar and I’ve used it for a few months now and can genuinely say that all the exercises and things they have in here are everything I’ve needed to learn guitar! Stoked with how the pickups are through AirPods and the only thing I wish there was more of is the Solo/Lick/Riff lessons. Cheers guys great app!",
    },
    {
      title: "Best Way to Self Learn",
      name: "Doc 50 Cal",
      body:
        "I chose the Gibson App last year on my birthday to learn something I’ve wanted to do for years and I’m STILL finding things in the App I didn’t know were there! This App seriously has MORE INFORMATION than you can imagine! Professional input, guides to take you through everything from theory to technique…and I PROMISE you can’t get this much info and instruction anywhere else for such a good price!!!! Gibson has set the bar and then exceeded it!!! Subscribe now and get to work...you won’t be disappointed!!!!",
    },
    {
      title: "Great App",
      name: "Indy1274",
      body:
        "Really impressed with this app is really helped me to improve after I picked my guitar back up after a long pause. Helps me focus and gives me structure. Lots of new stuff on there all the time. Well worth the money. Definitely take the advice and use headphones – massively improves note detection accuracy. One thing I would like to see is something that let me use my amp to jam along with backing and to get some points for doing so – the app amps good but not the same as cranking up the volume on a real one.",
    },
  ];

  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);
  let startX = 0;

  function stopAutoScroll() {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }

  function onTouchStart(e) {
    stopAutoScroll();
    startX = e.touches[0].clientX;
  }

  function onTouchEnd(e) {
    const endX = e.changedTouches[0].clientX;
    if (endX - startX > 40) {
      setCurrent((c) => (c === 0 ? reviews.length - 1 : c - 1));
      stopAutoScroll();
    } else if (startX - endX > 40) {
      setCurrent((c) => (c === reviews.length - 1 ? 0 : c + 1));
      stopAutoScroll();
    }
  }

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrent((c) => (c === reviews.length - 1 ? 0 : c + 1));
    }, 4000);
    return () => stopAutoScroll();
  }, []);

  function renderCard(rev, idx) {
    return (
      <div
        key={idx}
        className="flex-none w-full flex flex-col items-center space-y-3 px-4"
      >
        <Image
          src="/images/five_star.webp"
          alt="5 stars"
          width={80}
          height={80}
          className="object-contain"
        />
        <h3 className="text-[24px] fullfont-tradeGothicCondensedBold text-center">
          {rev.title}
        </h3>
        <p className="text-[14px] fullfont-tradeGothic text-gray-600 text-center">
          {rev.name}
        </p>
        <p className="text-[14px] md:text-[18px] fullfont-tradeGothic text-gray-700 text-center leading-relaxed max-w-[400px]">
          {rev.body}
        </p>
      </div>
    );
  }

  return (
    <div className={`${backgroundColor} py-10 w-full`}>
     
      <div className="max-w-screen-lg mx-auto px-4">
        <div
          className="relative overflow-hidden pb-8"
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          {/* sliding track */}
          <div
            className="flex transition-transform duration-300"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {reviews.map(renderCard)}
          </div>

          {/* dots */}
          <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {reviews.map((_, idx) => (
              <button
                key={idx}
                onClick={() => {
                  stopAutoScroll();
                  setCurrent(idx);
                }}
                className={`
                  w-2 h-2 rounded-full transition-all
                  ${idx === current ? "bg-gray-800" : "bg-gray-400"}
                `}
              />
            ))}
          </div>
        </div>
      </div>
      <a
        href="/user-reviews"
        className="block text-[14px] mx-auto md:text-[18px] fullfont-tradeGothic text-center mt-4 mb-4 text-blue-600 cursor-pointer hover:text-blue-800 transition-colors"
      >
        Read more
      </a>
    </div>
  );
}
